import { render, staticRenderFns } from "./DasCard.vue?vue&type=template&id=6ed1e55a&"
import script from "./DasCard.vue?vue&type=script&lang=js&"
export * from "./DasCard.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/components/views/dashboard/members/id/partial/cards/das-card.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports